import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  usePromiseWrapper,
  useStoreSelector,
  useCache,
  useActions,
} from '../../../helpers/hooks';
import { fetchDescription } from '../../../actions/infos';

export default function DescriptionCard({ id }) {
  const {
    i18n: { language },
  } = useTranslation();

  const description = useStoreSelector(
    (selector) => {
      try {
        const description = selector.getDescription(id);

        return description[language];
      } catch (e) {}
    },
    [language, id]
  );

  const fetchDescriptionAction = useActions(
    () => fetchDescription(language, id),
    [language, id]
  );

  const checkDescriptionCache = useCache('description', id, language);

  const [
    wrappedDescriptionFetch,
    descriptionLoading,
    descriptionError,
  ] = usePromiseWrapper({
    initPromise() {
      return fetchDescriptionAction();
    },
    cached() {
      return checkDescriptionCache();
    },
  });

  useEffect(() => {
    wrappedDescriptionFetch();
  }, [id, language]);

  if (descriptionLoading || descriptionError || !description) return null;

  return (
    <div className="block">
      <div
        className="description__card"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
}
